// ** React Imports
import { Fragment, useState, useEffect , useMemo, useCallback} from "react";

// ** MUI Components
import {
  Box,
  Button,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";

// ** Custom Component Import
import Icon from "components/icon";
import CustomTextField from "components/mui/text-field";
import CustomAutocomplete from "components/mui/autocomplete";
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view/";
import Popover from "@mui/material/Popover";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import InputAdornment from "@mui/material/InputAdornment";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { saveWorkRequirementService } from "screens/Requests/logic/SaveWorkRequirementService";
import { saveWorkRequirementSubService } from "screens/Requests/logic/SaveWorkRequirementSubService";
import CreateBundle from "screens/Services/component/CreateBundle";
import CreateBundleDialog from "screens/Services/component/CreateBundle";
import { useIndexLogic } from "screens/Services/logic/index-logic";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from 'react-toastify';

const AddBundle = ({
  open,
  handleBundleClose,
  //bundleList,
  // localSearch,
  // handleLocalSearch,  
  // handleClearSearch,
  
  fetchBundles,
  selectedBundles,
  setSelectedBundles,
  addBundle,
}) => {
   const { IndexProps } = useIndexLogic({toast});
   const { 
    openBundleDlg, 
    handleOpenBundleDlg, 
    handleCloseBundleDlg, 
    bundleContent, 
    BundleProps,
    bundleList
  } = IndexProps;
  
  const [openCreateBundle, setOpenCreateBundle] = useState(false);  
  const [anchorEl, setAnchorEl] = useState(null);  
  const op = Boolean(anchorEl);
  const id = op ? "industry-popover" : undefined;


  const handleOpenCreateBundle = () => setOpenCreateBundle(true);
  const handleCloseCreateBundle = () => setOpenCreateBundle(false);

  const renderBundleWithServices = (bundle) => {
    const isBundleSelected = selectedBundles.some(item => item.bundleID === bundle.bundleID);

    
    
    return (
      <TreeItem
        key={bundle.bundleID}
        itemId={`bundle-${bundle.bundleID}`}
        label={
          <FormControlLabel
            control={
              <Checkbox
                checked={isBundleSelected}
                onChange={() => handleToggle(bundle)}
              />
            }
            label={bundle.bundleName}
            sx={{ ml: 0 }}
          />
        }
      >
        {isBundleSelected && bundle.services?.map(service => (
          <TreeItem
            key={service.serviceOfferingID}
            itemId={`bundle-${bundle.bundleID}-service-${service.serviceOfferingID}`}
            label={
              <FormControlLabel
                control={
                  <Checkbox 
                    checked={true} 
                    disabled={true}
                  />
                }
                label={service.serviceOfferingName}
              />
            }
          />
        ))}
      </TreeItem>
    );
  };

  const getItemId = useCallback((item) => {
    if (!item.bundleID) {      
      return `gen-${item.bundleName}`
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');
    }
    return item.bundleID;
  }, []);

  const [searchText, setSearchText] = useState("");

// Filtered bundles based on search text
const filteredBundles = useMemo(() => {
  return bundleList.filter(bundle =>
    bundle.isActive && bundle.bundleName.toLowerCase().includes(searchText.toLowerCase())
  );
}, [bundleList, searchText]);

const memoizedBundleItems = useMemo(() => {
  const sortedBundles = [...filteredBundles].sort((a, b) =>
    a.bundleName.toLowerCase().localeCompare(b.bundleName.toLowerCase())
  );

  return sortedBundles.map(bundle => renderBundleWithServices(bundle));
}, [filteredBundles, selectedBundles]);


  const handleToggle = useCallback((item) => {
      setSelectedBundles(prev => {
        const exists = prev.some(i => i.bundleID === item.bundleID);
        if (exists) {
          return prev.filter(i => i.bundleID !== item.bundleID);
        } else {
          return [...prev, { 
            bundleID: item.bundleID,
            label: `${item.bundleName}`,
            bundleName: item.bundleName,
            services: item.services
          }];
        }
      });
    }, [setSelectedBundles]);

  const handleClick = useCallback((event) => {
      setAnchorEl(event.currentTarget);
    }, []);

    const handleClose = useCallback(() => {
      setAnchorEl(null);
    }, []);  
  
    
  // const renderTree = (nodes) => (
  //   <>
  //     <TreeItem
  //       label={
  //         <Box
  //           sx={{
  //             display: "flex",
  //             alignItems: "center",
  //             gap: 2,
  //           }}
  //         >
  //           <Icon icon="tabler:plus" />
  //           <Typography sx={{ my: 2 }}>Create a Bundle</Typography>
  //         </Box>
  //       }
  //       onClick={handleOpenCreateBundle}
  //     />
  //     {Object.keys(nodes).map((category) => (
  //       <TreeItem
  //         key={category}
  //         itemId={`parent-${category}`}
  //         label={
  //           <FormControlLabel
  //             control={
  //               <Checkbox
  //                 checked={nodes[category].every(
  //                   (subCategory) =>
  //                     selectedBundles &&
  //                     selectedBundles.some(
  //                       (item) =>
  //                         item.bundleID === subCategory.id &&
  //                         item.industryID === subCategory.industryID
  //                     )
  //                 )}
  //                 onChange={(e) => handleParentToggle(e, nodes[category])}
  //                 indeterminate={
  //                   nodes[category].some(
  //                     (subCategory) =>
  //                       selectedBundles &&
  //                       selectedBundles.some(
  //                         (item) =>
  //                           item.id === subCategory.id &&
  //                           item.industryID === subCategory.industryID
  //                       )
  //                   ) &&
  //                   !nodes[category].every(
  //                     (subCategory) =>
  //                       selectedBundles &&
  //                       selectedBundles.some(
  //                         (item) =>
  //                           item.id === subCategory.id &&
  //                           item.industryID === subCategory.industryID
  //                       )
  //                   )
  //                 }
  //               />
  //             }
  //             label={category}
  //             onClick={(e) => e.stopPropagation()}
  //           />
  //         }
  //       >
  //         {nodes[category].map((subCategory) => (
  //           <TreeItem
  //             key={subCategory.id}
  //             itemId={`child-${category}-${subCategory.id}`}
  //             label={
  //               <FormControlLabel
  //                 control={
  //                   <Checkbox
  //                     checked={selectedBundles.some(
  //                       (item) =>
  //                         item.id === subCategory.id &&
  //                         item.industryID === subCategory.industryID
  //                     )}
  //                     onChange={() => handleToggle(subCategory)}
  //                   />
  //                 }
  //                 label={subCategory.name}
  //               />
  //             }
  //           />
  //         ))}
  //       </TreeItem>
  //     ))}
  //   </>
  // );

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={open}
        onClose={() => handleBundleClose}
        PaperProps={{
          sx: {
            height: "100%",
            maxHeight: "50vh",
          },
        }}
      >        
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #D9D9D9",
            paddingBottom: "20px !important",
          }}
        >
          <Typography variant="h4" component="h2">
            Add Bundle
          </Typography>
          <Tooltip title="Close">
            <IconButton onClick={handleBundleClose}>
              <Icon icon="tabler:x" />
            </IconButton>
          </Tooltip>
        </DialogTitle>
        <DialogContent>
          <Box>
            <CustomTextField
              label="Bundle"
              required
              value={
                selectedBundles.length > 0
                  ? `${selectedBundles.length} bundle(s) selected`
                  : ""
              }
              placeholder="Select"
              onClick={handleClick}
              //error={Boolean(errors.industry)}
              //helperText={errors.industry}
              readOnly
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <ArrowDropDownIcon />
                  </InputAdornment>
                ),
              }}
            />
            <Popover
              id={id}
              open={op}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                horizontal: "left",
              }}
            >
              <Box
                sx={{
                  maxHeight: { xs: 190, md: 200, lg: 250, xl: 400 },
                  minWidth: 300,
                  p: 2,
                }}
              >
                <CustomTextField
                fullWidth
                placeholder="Search Bundles..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon icon="tabler:search" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      {searchText && (
                        <IconButton
                          edge="end"
                          onClick={() => {setSearchText("")}}
                          aria-label="clear"
                          sx={{ mr: 2 }}
                        >
                          <Icon icon="tabler:x" />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
                sx={{ mb: 2 }}
              />
                <SimpleTreeView
                  defaultCollapseIcon={<ExpandMoreIcon />}
                  defaultExpandIcon={<ChevronRightIcon />}
                >
                  <TreeItem
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer", p: 1 ,fontWeight: 'bold'}}  onClick={handleOpenBundleDlg}>
                        {/* <Icon icon="tabler:plus" /> */}
                        <Typography sx={{ fontWeight: 'inherit' }}>+ Create a Bundle</Typography>
                      </Box>
                    }
                    onClick={handleOpenCreateBundle}
                  />
                  {memoizedBundleItems}
                </SimpleTreeView>
              </Box>
            </Popover>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px 24px !important",
            boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`,
            zIndex: 1,
          }}
        >
          <Button variant="contained"  color ="info" onClick={()=> {handleBundleClose();setSearchText('');}}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="main"
            onClick={() => {addBundle(); setSearchText('');}}
            disabled={selectedBundles.length === 0}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>

       <CreateBundleDialog
        open={openBundleDlg}
        handleClose={handleCloseBundleDlg}
        bundleContent={bundleContent}       
        BundleProps={BundleProps}       
      />      
    </>
  );
};

export default AddBundle;
